import React, { useState, useCallback } from 'react'
import { Copy, Check } from 'lucide-react'
import { Button } from './button'
import { cn } from '@/lib/utils'

const CopyButton = ({ text, className, variant = 'outline', size = 'sm', onCopy, children, ...props }) => {
  const [isCopied, setIsCopied] = useState(false)

  const handleCopy = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(text)
      setIsCopied(true)

      // Call optional callback
      if (onCopy) {
        onCopy(text)
      }

      // Reset after 2 seconds
      setTimeout(() => {
        setIsCopied(false)
      }, 2000)
    } catch (error) {
      console.error('Failed to copy text:', error)
      // Fallback for older browsers
      try {
        const textArea = document.createElement('textarea')
        textArea.value = text
        textArea.style.position = 'fixed'
        textArea.style.left = '-999999px'
        textArea.style.top = '-999999px'
        document.body.appendChild(textArea)
        textArea.focus()
        textArea.select()
        document.execCommand('copy')
        textArea.remove()
        setIsCopied(true)

        if (onCopy) {
          onCopy(text)
        }

        setTimeout(() => {
          setIsCopied(false)
        }, 2000)
      } catch (fallbackError) {
        console.error('Fallback copy failed:', fallbackError)
      }
    }
  }, [text, onCopy])

  return (
    <Button
      variant={variant}
      size={size}
      className={cn(
        'transition-all duration-200 hover:scale-105',
        isCopied ? 'text-green-600 border-green-200 bg-green-50' : 'text-gray-600 border-gray-200 hover:bg-gray-50',
        className
      )}
      onClick={handleCopy}
      {...props}
    >
      <div className="flex items-center gap-1">
        {isCopied ? <Check className="w-4 h-4 animate-in fade-in duration-200" /> : <Copy className="w-4 h-4" />}
        {children}
      </div>
    </Button>
  )
}

export { CopyButton }
